module.exports = __webpack_public_path__ + "assets/img/store-reg-banner-05.ca5fd42d.png";